package anjuros.development.modules

import anjuros.development.components.language.ResKey
import anjuros.development.util.Res

enum class Nearby(
    val image:String,
    val distance: String,
    val description: ResKey,
    val link: String

) {
    Nearby1(
        image = Res.Image.nearby_bialka,
        distance = "8.5 km",
        description = ResKey.NEARBY1,
        link = "https://bialkatatrzanska.pl/"
    ),
    Nearby2(
        image = Res.Image.nearby_termy,
        distance = "9 km",
        description = ResKey.NEARBY2,
        link = "https://www.termabania.pl/"
    ),
    Nearby3(
        image = Res.Image.nearby_castle,
        distance = "15 km",
        description = ResKey.NEARBY3,
        link = "https://zamekniedzica.pl/"
    )
}